export default __webpack_public_path__ + "static/media/wallet.819bd878.svg";